import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { useTheme } from '../../../../../theme';
import { Money as MoneyType } from '../../../../../Money/types';
import Money from '../../../../../Money';
import { CheckinCard, CheckinCardItem } from '@shared/CheckinCard';

interface PriceItem {
	label: React.ReactNode;
	price: MoneyType;
}

interface Props {
	className?: string;
	prices?: PriceItem[];
	totalPrice: MoneyType;
}

const Receipt: React.FC<Props> = ({ className, prices, totalPrice }) => {
	const { t } = useTranslation('Exchange');
	const { Receipt: theme } = useTheme('Widgets').Exchange;

	return (
		<CheckinCard className={cn(theme.root, className)}>
			<CheckinCardItem className={theme.prices} delimiter="line" delimiterGap>
				{prices?.map(priceItem => (
					<div className={theme.row}>
						<span className={theme.label}>{priceItem.label}</span>
						<Money moneyClassName={theme.money} money={priceItem.price} />
					</div>
				))}
			</CheckinCardItem>
			<div className={cn(theme.row, theme.row_total)}>
				<span className={theme.label}>{t('Receipt.Total')}</span>
				<Money moneyClassName={theme.money} money={totalPrice} />
			</div>
		</CheckinCard>
	);
};

export default Receipt;
